import { createSlice } from '@reduxjs/toolkit';
import { TipoPagoBoleta } from 'config';
import { TrackingState } from './trackingState.interface';

const initialState: TrackingState = {
  distribuidora: {
    urlLogo: '',
  },
  servicio: {
    estadosAnteriores: [],
    datos: {},
  },
  usuario: {
    codigoEstadoSuministro: '',
    codDistribuidora: '',
    comuna: '',
    numeroServicio: '',
    localidad: '',
  },
  facturacion: {
    respuesta: {
      ultimoPago: {
        fechaBoleta: '',
        fechaEmision: '',
        fechaVencimiento: '',
        linkPaperlessBoleta: '',
        montoPago: '',
        numeroBoleta: '',
      },
      cobroActual: {
        codEmpresa: '',
        estadoPago: TipoPagoBoleta.DEFAULT,
        fechaEmisionBoleta: '',
        fechaVencimiento: '',
        linkPaperlessBoleta: '',
        montoPago: '',
        numeroBoleta: '',
      },
      penultimaBoleta: {
        estadoPago: TipoPagoBoleta.DEFAULT,
        fechaEmision: '',
        fechaVencimiento: '',
        linkPaperlessBoleta: '',
        montoBoleta: '',
        montoPago: '',
        numeroBoleta: '',
      },
    },
  },
  menuAbierto: false,
};

export const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    actualizarLogo: (state, action) => {
      state.distribuidora.urlLogo = action.payload?.urlLogo || state.distribuidora.urlLogo;
    },
    actualizarServicioTracking: (state, action) => {
      state.servicio.estadosAnteriores = action.payload.estadosAnteriores
        ? [...action.payload.estadosAnteriores]
        : [...state.servicio.estadosAnteriores];
      state.servicio.datos = action.payload.datos || state.servicio.datos;
    },
    actualizarUsuario: (state, action) => {
      state.usuario.codigoEstadoSuministro = action.payload.codigoEstadoSuministro || state.usuario.codigoEstadoSuministro;
      state.usuario.codDistribuidora = action.payload.codDistribuidora || state.usuario.codDistribuidora;
      state.usuario.comuna = action.payload.comuna || state.usuario.comuna;
      state.usuario.localidad = action.payload.localidad || state.usuario.localidad;
      state.usuario.numeroServicio = action.payload.numeroServicio || state.usuario.numeroServicio;
    },
    actualizarEstadoMenuAbierto: (state, action) => {
      state.menuAbierto = action.payload.menuAbierto;
    },
    actualizarFacturacion: (state, action) => {
      state.facturacion.respuesta = action.payload.respuesta || state.facturacion.respuesta;
    },
  },
});

export const { actualizarServicioTracking, actualizarLogo, actualizarUsuario, actualizarEstadoMenuAbierto, actualizarFacturacion } =
  trackingSlice.actions;

export default trackingSlice.reducer;
